var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main_button"}},[_c('router-link',{style:([{ color: _vm.is_not_done ? 'red' : ''}]),attrs:{"to":{path: ("" + _vm.href_link)}}},[_c('br'),_c('h3',[_vm._v(_vm._s(_vm.text))]),_c('br')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }